import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["MobilePublicationsFilters"] */ "/vercel/path0/src/components/filters/mobilePublicationsFilters.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApplyButton"] */ "/vercel/path0/src/components/job/applyButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LinkedinShareButton"] */ "/vercel/path0/src/components/job/linkedinShareButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JobOfferProvider"] */ "/vercel/path0/src/contexts/jobOffer.tsx");
